import { render, staticRenderFns } from "./ExceptionsOVG.vue?vue&type=template&id=430a9236&lang=pug"
import script from "./ExceptionsOVG.vue?vue&type=script&lang=js"
export * from "./ExceptionsOVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports